import { UploadFileToFirebase } from '@/libs'

import {
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    COMPONENT_DEFUALT_FILTERS,
    ENDPOINTS
} from '@/data'

import {
    CategoryValidation,
    ClipboardValidation,
    ImageValidation,
    LinkValidation,
    NameValidation,
    PriceValidation,
    Request,
    TagsValidation,
    VideoValidation
} from '@/helpers'

const Update = async (props: ClientComponentUpdateFunctionProps) => {
    const {
        Form,
        Errors,
        SetComponentState,
        SetState,
        InitNotification
    } = props

    try {
        const {
            _id,
            Name,
            Category,
            Tags,
            Link,
            Image,
            Clipboard,
            Price,
            Video
        } = Form

        const clone_errors = structuredClone(Errors)

        Object.keys(clone_errors).forEach(key => {
            clone_errors[key] = true
        })

        SetState({ Errors: clone_errors })

        const nameIsValid = NameValidation(Name)
        const linkIsValid = LinkValidation(Link)
        const imageIsValid = ImageValidation(Image)
        const tagsAreValid = TagsValidation()
        const categoryIsValid = CategoryValidation(Category)
        const clipboardIsValid = ClipboardValidation(Clipboard)
        const priceValidation = PriceValidation(Price)
        const videoValidation = VideoValidation(Video)

        const isValid =
            !nameIsValid.error &&
            !linkIsValid.error &&
            !imageIsValid.error &&
            !tagsAreValid.error &&
            !categoryIsValid.error &&
            !clipboardIsValid.error &&
            !priceValidation.error &&
            !videoValidation.error

        if (isValid) {
            SetState({ Loading: true })

            const sideover_panel = document.querySelector('#sideover-panel')

            if (sideover_panel) sideover_panel.scrollBy({
                top: -sideover_panel.scrollHeight,
                behavior: 'smooth'
            })

            const image_url = typeof Image === 'string' ? Image : await UploadFileToFirebase(Image, '/images/')
            const video_url = typeof Video === 'string' ? Video : await UploadFileToFirebase(Video, '/videos/')

            if (image_url && video_url) {
                const { success, message } = await Request({
                    path: ENDPOINTS.UPDATE_COMPONENT,
                    method: 'PATCH',
                    body: {
                        _id,
                        Name,
                        Category,
                        Tags,
                        Link,
                        Image: image_url,
                        Video: video_url,
                        Clipboard,
                        Price
                    }
                })

                if (success) {
                    SetComponentState({
                        Filters: {
                            ...COMPONENT_DEFUALT_FILTERS,
                            random: Math.random() + Date.now()
                        }
                    })

                    const components_panel = document.querySelector('#component-list')

                    if (components_panel) components_panel.scrollBy({
                        top: -components_panel.scrollHeight,
                        behavior: 'smooth'
                    })

                    InitNotification(message)

                    SetState({
                        Form: COMPONENT_DEFAULT_FORM,
                        Errors: COMPONENT_DEFAULT_ERRORS,
                        Loading: false,
                        Mode: 'create',
                        Open: false
                    })
                }

                else {
                    InitNotification(message)
                    SetState({ Loading: false })
                }
            }

            else {
                InitNotification('Image didn\'t uploaded, so we canceled the process of creating component!')
                SetState({ Loading: false })
            }
        }
    }

    catch (error) {
        console.error(error)

        InitNotification('Something went wrong while trying to update component!')
        SetState({ Loading: false })
    }
}

export default Update
